import { CKLayoutGrid } from 'clearkit';
import Helmet from 'react-helmet';

import CompaniesList from './CompaniesList';
import { useTargetMarket } from './hooks/useTargetMarket';
import { Sidebar } from './Sidebar';

const TargetMarketsPage = () => {
  const {
    search,
    setSearch,
    id,
    modifiedNotSaved,
    setTargetMarket,
  } = useTargetMarket();

  return (
    <>
      <Helmet>
        <title>Target Markets</title>
      </Helmet>

      <CKLayoutGrid className="w-full" gap="0" gridTemplateColumns="auto 1fr">
        <Sidebar
          id={id}
          modifiedNotSaved={modifiedNotSaved}
          search={search}
          setSearch={setSearch}
          setTargetMarket={setTargetMarket}
        />

        <CompaniesList search={search} />
      </CKLayoutGrid>
    </>
  );
};

export { TargetMarketsPage };
